import React, { useState } from "react";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import CustomModal from "../components/modal/Modal";
import ManufacturingTopSection from "../components/manufacturing/ManufacturingTopSection";
import IndustryInfoSection from "../components/LearningPage/IndustryInfoSection";
import MiniFactorySection from "../components/LearningPage/MiniFactorySection";
import FeatureCarousel from "../components/LearningPage/FeatureCarousel";
import WhyChooseSection from "../components/LearningPage/WhyChooseSection";
import allInOneImage from "../assets/images/all-in-one.png";
import handsOnLearningImage from "../assets/images/hands-on-learning.jpg";
import versatilityImage from "../assets/images/versatility.png";
import heroBackground from "../assets/images/learning/learning-hero-bg.png";

import "./page.css";
import "./LearningPage.css";

const LearningPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  const handleNext = () =>
    setCurrentSlide((prev) => (prev + 1) % cardData.length);
  const handlePrev = () =>
    setCurrentSlide((prev) => (prev === 0 ? cardData.length - 1 : prev - 1));

  const getPosition = (index, current, total) => {
    if (index === current) return "center";
    if (index === (current - 1 + total) % total) return "left";
    if (index === (current + 1) % total) return "right";
    return "hidden";
  };

  const whyChooseData = {
    title: "Technologies covered",
    reasons: [
      "Automation: Enhancing efficiency through streamlined processes.",
      "Robotics: Designing intelligent machines for various tasks.",
      "Industry 4.0: Revolutionizing manufacturing with advanced technologies.",
      "IoT: Connecting devices for data-driven insights and automation.",
      "Embedded Systems: Tailoring computing systems for specific functions.",
      "AI: Empowering machines to learn and make autonomous decisions.",
    ],
  };

  const cardData = [
    {
      imageUrl: handsOnLearningImage,
      icon: "ri-calendar-check-line",
      title: "Hands on Learning",
      linkUrl: "#",
    },
    {
      imageUrl: versatilityImage,
      icon: "ri-movie-2-line",
      title: "Versatility",
      linkUrl: "#",
    },
    {
      imageUrl: allInOneImage,
      icon: "ri-brush-4-line",
      title: "All in One",
      linkUrl: "#",
    },
  ];

  return (
    <div
      className="learning-page"
      style={{ backgroundColor: "rgba(255, 255, 255, 0.9)" }}
    >
      <Navbar />
      <ManufacturingTopSection
        title="Plug-n-Play Mini-Factory for schools"
        description="Bring real-world manufacturing into your classroom. Empower students with hands-on learning in robotics, automation, and Industry 4.0 technologies."
        backgroundImage={heroBackground}
        buttonText="Watch Video"
        videoUrl="https://youtu.be/fyKmr4lbztE"
      />
      <IndustryInfoSection />
      <MiniFactorySection />
      <FeatureCarousel
        {...{ cardData, currentSlide, handlePrev, handleNext, getPosition }}
      />

      <section>
        <div className="talk-to-us-manufacturing"></div>
        {showModal && (
          <CustomModal
            modalTitle="Perfect for schools, Book Demo Now"
            closeButtonName="Close"
            actionButtonName="Book Demo"
            onClose={closeModal}
          />
        )}
      </section>

      <WhyChooseSection data={whyChooseData} />
      <Footer />
    </div>
  );
};

export default LearningPage;
